export enum HubMethods {
    RetrieveCurrentCall = 'retrieveCurrentCall',
    OnCurrentCall = 'onCurrentCall',
    CreateMeeting = 'createMeeting',
    ListMeetings = 'listMeetings',
    OnMeetingList = 'onMeetingList',
    OnCallStatus = 'onCallStatus',
    InviteToCurrentCall = 'inviteToCurrentCall',
    EndCurrentCall = 'endCurrentCall',
    RetrieveChat = 'retrieveChat',
    OnChat = 'onChat',
    UpdateChat = 'updateChat',
    SendChatMessage = 'sendChatMessage',
    OnChatMessage = 'onChatMessage',
    ListChatMessages = 'listChatMessages',
    OnChatMessageList = 'onChatMessageList',
    DeleteChatMessage = 'deleteChatMessage',
    CreateTask = 'createTask',
    OnTaskCreate = 'onTaskCreate',
    UpdateTask = 'updateTask',
    DeleteTask = 'deleteTask',
    ListTasks = 'listTasks',
    OnTaskList = 'onTaskList',
    ImportTranscript = 'importTranscript',
}
